import React from "react";

/**
 * Embeds the Knight Insurance NinjaPipe "Get A Quote" form as an iframe.
 * Fixed 600px height per the form's authored layout; expands to `maxWidth`
 * (default 920px) — stays fully responsive on smaller screens.
 */
export default function EmbeddedForm({
  src = "https://knight-insurance-solutions.ninjapipe.app/forms/get-a-quote?hidePrivacyNotice=1",
  title = "Get A Quote",
  height = 900,
  maxWidth = 500,
}) {
  return (
    <div
      className="w-full mx-auto"
      style={{ maxWidth: `${maxWidth}px` }}
    >
      <iframe
        src={src}
        title={title}
        width="100%"
        height={height}
        frameBorder="0"
        className="block w-full"
        style={{
          border: "none",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
        loading="lazy"
        data-testid="embedded-form"
      />
    </div>
  );
}
